const collection = {
    slug: "comme-des-garcons-homme-plus-2024ss-beyond-reality-guide",
    metaTitle:
      "コムデギャルソンオムプリュス 2024SSとは｜Beyond Realityと買取・レンタルガイド",
    metaDescription:
      "COMME des GARÇONS HOMME PLUS 2024SS『Beyond Reality』を解説。川久保玲がトロンプルイユ、騙し絵、反転したジャケット、カーテン、玉座、祭壇、再構築されたテーラードによって現実と仮象の境界を揺らしたコレクション。2024SSアイテムの買取相談、コムデギャルソンオムプリュスのレンタル、ブランド一覧への導線までEnclopediaが詳しく案内します。",
    metaKeywords:
      "コムデギャルソンオムプリュス 2024SS,COMME des GARCONS HOMME PLUS 2024SS,Beyond Reality,コムデギャルソンオムプリュス Beyond Reality,コムデギャルソンオムプリュス 買取,COMME des GARCONS HOMME PLUS 買取,コムデギャルソンオムプリュス レンタル,COMME des GARCONS HOMME PLUS レンタル,コムデギャルソンオムプリュス トロンプルイユ,コムデギャルソン 騙し絵,コムデギャルソンオムプリュス テーラード,コムデギャルソンオムプリュス ジャケット,コムデギャルソンオムプリュス アーカイブ,コムデギャルソンオムプリュス 名作,川久保玲 Beyond Reality,コムデギャルソン 買取,COMME des GARCONS 買取,Enclopedia,アンクロペディア",
    canonicalPath:
      "/archive_collection/comme-des-garcons-homme-plus-2024ss-beyond-reality-guide",
    heroImage:
      "media/archive_fashion/archive17.png",
    heroImageAlt:
      "COMME des GARÇONS HOMME PLUS 2024SS Beyond Reality トロンプルイユと現実の攪乱を解説するEnclopediaアーカイブガイド画像",
    heroNumber: "16 / BEYOND REALITY",
    label: "ARCHIVE COLLECTION STUDY",
    title:
      "COMME des GARÇONS HOMME PLUS 2024SS『Beyond Reality』",
    lead:
      "COMME des GARÇONS HOMME PLUS 2024SS『Beyond Reality』。\n\n目に見えるものは、本当に現実なのか。\n手に触れられる服は、本当にそのままの意味で存在しているのか。\n\nこのシーズンで川久保玲が扱ったのは、現実と仮象の境界です。\nジャケットの上に描かれたジャケット。\nカーテン、玉座、祭壇のようなモチーフ。\nトロンプルイユ、つまり騙し絵によって、服は単なる衣服ではなく、見せかけと実体の関係を揺らす装置になります。\n\nコムデギャルソンオムプリュスが得意としてきたテーラードは、ここでさらに別の段階へ進みます。\nジャケットは反転し、袖はずれ、カーテンのように開き、プリントされた別の服や権威のモチーフをまといます。\n\nEnclopediaでは、この2024SSを、単なるシュルレアリスム的なコレクションではなく、男性服が持つ“権威らしさ”や“正しさ”の見せかけを暴くシーズンとして読み解きます。",
    keywordLine: [
      "beyond reality",
      "trompe-l'œil",
      "tailoring illusion",
      "homme plus buyback",
    ],
    thesis:
      "2024SS『Beyond Reality』の重要性は、トロンプルイユや反転したテーラードによって、服の実体と見せかけ、そして男性服がまとってきた権威の仮象性を揺らした点にあります。",
    whyTitle:
      "なぜ『Beyond Reality』は、ただの騙し絵コレクションではないのか。",
    whyBody:
      "トロンプルイユは、二次元の絵で三次元の存在を錯覚させる技法です。\n服の上に服を描く。\nジャケットの上に、もう一つのジャケットを見せる。\nカーテンや玉座や祭壇のような、権威を連想させるモチーフを身体の上に置く。\n\n一見すると、それは視覚的な遊びに見えます。\nしかしCOMME des GARÇONS HOMME PLUS 2024SSでは、その遊びが男性服の根本へ向かっています。\n\nスーツやジャケットは、男性服の中で長く“正しさ”や“社会性”や“権威”を表してきました。\nけれど、その権威は本当に実体なのか。\nそれとも、ラペル、肩、前合わせ、格式ある柄、椅子や祭壇のような記号によって作られた見せかけなのか。\n\n『Beyond Reality』は、服を通してその境界を揺らします。\n現実を超えるというより、私たちが現実だと思っているものが、どれだけ視覚的な約束事に支えられているかを見せるコレクションです。\n\nEnclopediaでは、この文脈を入口に、2024SSの買取相談、コムデギャルソンオムプリュス全体のレンタル体験、そしてブランドページへの導線を設計します。",
    pillars: [
      {
        number: "01",
        title: "TROMPE-L'ŒIL AS CRITIQUE",
        text:
          "騙し絵は、単なる視覚的な遊びではありません。服の実体と見せかけをずらし、男性服が持つ権威の記号性を暴くための方法です。",
      },
      {
        number: "02",
        title: "TAILORING BEYOND REALITY",
        text:
          "コムデギャルソンオムプリュスのテーラードは、身体を整えるための服ではなくなります。反転し、ずれ、カーテンのように開き、現実の服から仮象の服へ変化します。",
      },
      {
        number: "03",
        title: "BUYBACK FIRST, RENTAL NEXT",
        text:
          "2024SSは市場流通も見込める重要シーズンです。Enclopediaでは、買取相談を入口に、コムデギャルソンオムプリュス全体のレンタル体験へも接続します。",
      },
    ],
    readingTitle:
      "トロンプルイユ、反転ジャケット、カーテン、権威から読む『Beyond Reality』。",
    readingIntro:
      "このコレクションは、服に絵を描いたから面白いのではありません。なぜジャケットにジャケットを描くのか、なぜカーテンや玉座や祭壇が服に現れるのか、なぜテーラードが反転し、ずれ、現実を超えようとするのかを見ることで、コムデギャルソンオムプリュスらしい男性服への問いが見えてきます。",
    observations: [
      {
        index: "01",
        title:
          "ジャケットは、本当にジャケットなのか",
        text:
          "2024SSでは、ジャケットそのものが疑わしい存在になります。\nロングジャケットが後ろ前になり、ウエストから上下逆のジャケットが付く。\n袖の位置は極端にずれ、袖を通すという基本的な機能すら揺らぎます。\n\nつまり、ジャケットは身体を整える服ではなくなります。\nジャケットらしい形を持ちながら、普通のジャケットとしては機能しない。\n\nコムデギャルソンオムプリュスは、男性服の基本単位であるジャケットを使って、“服らしさ”そのものを疑わせています。",
      },
      {
        index: "02",
        title:
          "トロンプルイユは、服の上にもう一つの現実を作る",
        text:
          "トロンプルイユは、騙し絵の技法です。\n平面に描かれたものが、まるで立体として存在しているように見える。\n\nこのシーズンでは、ジャケットの上にジャケットの図柄が置かれ、カーテン、玉座、祭壇のようなモチーフが服に現れます。\n\n重要なのは、これが単なるプリントではないということです。\n服の上に、もう一つの服や空間や権威のイメージが重ねられている。\n身体は、現実の服と仮象の服を同時にまとうことになります。",
      },
      {
        index: "03",
        title:
          "カーテンは、身体を隠すものでもあり、舞台を開くものでもある",
        text:
          "カーテンは、内側と外側を分けるものです。\n隠すものでもあり、開くものでもあり、舞台や権威ある空間を演出するものでもあります。\n\n2024SSでは、服がカーテンのように左右に分かれ、タッセルで留められる構造も見られます。\nそこでは身体が、日常の身体というより、舞台上の存在のように見えてきます。\n\n服は身体を包むだけではなく、身体の前に幕を作る。\n現実の身体と、演出された身体の境界が曖昧になります。",
      },
      {
        index: "04",
        title:
          "玉座や祭壇は、権威の仮象として身体に乗る",
        text:
          "玉座や祭壇は、ただのインテリアではありません。\n王権、宗教、儀式、格式、権威を連想させるモチーフです。\n\nそれらが服の上に現れるとき、身体は権威そのものをまとうように見えます。\nしかし、それは本物の権威ではありません。\nプリントされた仮象であり、視覚的なイメージです。\n\nここに、このコレクションの鋭さがあります。\n権威は実体なのか、それとも見せかけなのか。\nコムデギャルソンオムプリュスは、服の表面にその問いを置いています。",
      },
      {
        index: "05",
        title:
          "テーラードの再構築は、男性服の“正しさ”を揺らす",
        text:
          "テーラードは、男性服の正しさを象徴してきた構造です。\n肩の位置、ラペル、前合わせ、袖の位置、着用の仕方。\nそれらが整っているからこそ、ジャケットは社会的な服として成立します。\n\nしかし2024SSでは、その正しさがずらされます。\n後ろ前、上下逆、袖の位置の逸脱、カーテンのような開閉。\n\nこのずれによって、テーラードは身体を社会へ適応させる服ではなく、社会的な正しさそのものを疑う服になります。",
      },
      {
        index: "06",
        title:
          "シューズまで“現実を超える”構造になっている",
        text:
          "FASHIONSNAPは、キッズラブゲイトとのコラボレーションで、プレーントゥシューズをベースにつま先が二股に分かれたり、上下で二足が重なったようなフォルムが登場したことを紹介しています。\n\n足元もまた、現実の形からずれています。\n靴は普通、歩くための道具です。\nしかしこのシーズンでは、靴そのものがシュルレアリスム的なオブジェのように見える。\n\n服だけでなく、身体を支える足元まで現実を疑わせる。\nここにコレクション全体の一貫性があります。",
      },
      {
        index: "07",
        title:
          "NIKE ACGとの接続は、現実的な機能服を仮象の世界へ引き込む",
        text:
          "2024SSでは、NIKE ACGとのコラボレーションも登場しています。\nACGはアウトドア、機能、環境への対応を連想させるラインです。\nつまり、かなり現実的な機能服の文脈を持っています。\n\nそのACGが『Beyond Reality』の中に置かれることで、機能服ですら現実の側に留まりません。\n現実的な道具としての靴が、コムデギャルソンオムプリュスの仮象的な世界へ接続される。\n\nEnclopediaの視点では、このコラボは単なる話題性ではなく、現実的な機能と非現実的な視覚の接点として読むことができます。",
      },
      {
        index: "08",
        title:
          "2024SSは、最新アーカイブとして流通価値を見極めやすい",
        text:
          "2024SSは、すでに市場流通が見え始めている比較的新しいシーズンです。\nトロンプルイユ、テーラードの再構築、NIKE ACG、キッズラブゲイト、ジョージコックスなど、検索されやすい要素も多い。\n\nそのため、コムデギャルソンオムプリュスの買取導線として非常に相性が良いシーズンです。\nEnclopediaでは、2024SSを単なる新作情報としてではなく、今後のアーカイブ候補として見ます。\n\n買取相談では、タグ、シーズン、ルックとの近さ、状態、サイズ、素材、付属品、コラボレーションの有無まで含めて確認します。",
      },
      {
        index: "09",
        title:
          "レンタルで分かるのは、仮象を着る身体感覚",
        text:
          "2024SSの服は、画像で見るとプリントや形の奇妙さが先に目に入ります。\nしかし実際に着ると、ジャケットのずれ、カーテンのような開き、袖の位置、プリントされたもう一つの服や空間が、身体の上でどう作用するかが分かります。\n\n現実の服を着ているのに、仮象の服や空間も同時にまとっている。\nこの感覚は、写真だけでは伝わりにくい。\n\nEnclopediaでは、記事で背景を読み、レンタルで身体感覚として確かめる導線を作ります。",
      },
    ],
    quote:
      "Beyond Realityは、現実離れした服ではない。私たちが現実だと思っている服や権威が、どれだけ見せかけに支えられているかを暴くコレクションです。",
    perspectiveTitle:
      "Enclopediaは、HOMME PLUSを“見る服”ではなく“着て仮象を理解するアーカイブ”として扱う。",
    perspectiveCards: [
      {
        number: "01",
        title: "BUYBACK FIRST",
        text:
          "2024SSは市場流通が見込める重要シーズンです。Enclopediaでは、コムデギャルソンオムプリュス 2024SSの買取相談を、シーズン文脈込みで受け付けます。",
      },
      {
        number: "02",
        title: "RENTAL EXPERIENCE",
        text:
          "コムデギャルソンオムプリュスのテーラードやトロンプルイユは、実際に着ることで理解が深まります。構造、ずれ、プリント、身体との距離をレンタルで体験できる導線へつなげます。",
      },
    ],
    experienceTitle:
      "コムデギャルソンオムプリュス 2024SSを売る前に、その一着がどの文脈にあるかを確認する。",
    experienceBody:
      "COMME des GARÇONS HOMME PLUS 2024SSの買取では、ブランド名だけでなく、シーズン、テーマ、ルック、素材、状態、サイズ、現在の需要が重要です。\n今回の記事では『Beyond Reality』を中心に解説していますが、Enclopediaが見ているのは2024SSだけではありません。\nCOMME des GARÇONS HOMME PLUS全般、COMME des GARÇONS、COMME des GARÇONS HOMME、JUNYA WATANABE、noir kei ninomiyaなど、コムデギャルソン全体を対象に、その一着がどの時代のどんな価値を持つのかを確認します。\n\nBeyond Realityを知ることは、これから市場に出てくるコムデギャルソンオムプリュスの一着の価値を見極める入口になります。",
    experienceItems: [
      "COMME des GARÇONS HOMME PLUS 2024SSのタグ・シーズンを確認する",
      "Beyond Realityに近いトロンプルイユ、ジャケットプリント、カーテン構造を撮影する",
      "反転ジャケット、上下逆の構造、袖位置のずれなど再構築ディテールを確認する",
      "NIKE ACG、KIDS LOVE GAITE、GEORGE COXなどコラボレーションの有無を確認する",
      "サイズ・状態・購入時期・付属品を確認する",
      "2024SSか不明な場合もLINEで写真を送る",
    ],
    archiveItemsTitle:
      "2024SSを入口に、コムデギャルソンオムプリュスの買取・レンタルへつなげる。",
    archiveItemsBody:
      "Enclopediaでは、COMME des GARÇONS HOMME PLUSを単なるブランド古着としてではなく、川久保玲の男性服への問い、シーズン背景、現在の需要まで含めて見ています。この記事で2024SS Beyond Realityの重要性に触れた方は、所有しているコムデギャルソンオムプリュスの一着も、まずはLINEでご相談ください。",
    archiveItems: [
      {
        label: "BUYBACK FOCUS 01",
        title: "COMME des GARÇONS HOMME PLUS買取ページへ",
        productPath:
          "/brand_buyback/comme-des-garcons-homme-plus",
        productImage: "",
        text:
          "2024SS Beyond Realityを含むコムデギャルソンオムプリュスのジャケット、パンツ、スーツ、シャツ、トロンプルイユやテーラード再構築のアーカイブまで。オムプリュスの買取対象と査定視点を確認できます。",
      },
      {
        label: "RENTAL FOCUS 02",
        title: "レンタルできるコムデギャルソンオムプリュスを見る",
        productPath:
          "/brand/COMME%20DES%20GARCONS%20HOMME%20PLUS（コムデギャルソンオムプリュス）/?number=11",
        productImage: "",
        text:
          "コムデギャルソンオムプリュスのシーズン性やシルエットは、実際に着ることで理解が深まります。Enclopediaでコムデギャルソンオムプリュスのアーカイブを体験できます。",
      },
      {
        label: "BRAND FOCUS 03",
        title: "COMME des GARÇONS HOMME PLUSブランド一覧へ",
        productPath:
          "/brand/COMME%20DES%20GARCONS%20HOMME%20PLUS（コムデギャルソンオムプリュス）/?number=11",
        productImage: "",
        text:
          "2024SSだけでなく、コムデギャルソンオムプリュスのテーラード、パンツ、シャツ、シーズンテーマの強いアイテムを一覧で確認できます。",
      },
    ],
    finalCta: {
      title:
        "Beyond Realityを読んだら、次はコムデギャルソンオムプリュスの価値を相談する。",
      body:
        "COMME des GARÇONS HOMME PLUS 2024SSは、トロンプルイユとテーラードの再構築によって、現実と仮象、服と権威の境界を揺らしたシーズンです。\nEnclopediaでは、2024SSの買取相談を入口に、コムデギャルソンオムプリュス全体のレンタル体験やブランド一覧へつなげます。\nまずはLINEでタグ・品質表示・全体写真をお送りください。",
      buttonLabel: "コムデギャルソンオムプリュスをLINEで事前査定する",
      buttonHref: "https://line.me/R/ti/p/@240yzqkh",
    },
  };
  
  export default collection;